import catalog from "../../../shared/projectDiagnosticCatalog.json";

function normalizeCategoryKey(category) {
  if (!category) return null;

  const rawKey = String(category).trim();
  const lowerKey = rawKey.toLowerCase();

  return catalog.aliases[rawKey] || catalog.aliases[lowerKey] || lowerKey;
}

export function getProjectDiagnosticContent(category) {
  const normalizedKey = normalizeCategoryKey(category);
  const categoryContent =
    (normalizedKey && catalog.categories[normalizedKey]) || {};
  const fallback = catalog.fallback || {};

  return {
    requestedKey: category || null,
    normalizedKey,
    categoryLabel: categoryContent.label || fallback.label || "Home Project",
    categoryType:
      categoryContent.categoryType || fallback.categoryType || "planning",
    title:
      categoryContent.title || fallback.title || "What Kind of Project Help Do I Need?",
    description:
      categoryContent.description ||
      fallback.description ||
      "Answer a few questions to understand the urgency, scope, and next step for your home project.",
    questions:
      Array.isArray(categoryContent.questions) && categoryContent.questions.length > 0
        ? categoryContent.questions
        : fallback.questions || [],
  };
}

export { normalizeCategoryKey, catalog as projectDiagnosticCatalog };
